/*
TDA specific logic, Shared by all TDAs
Needed for domain restructure, local image paths (/web_docs/)
need to be replaced with /TDACODE/ unless GST10, in which case we need 'GS10'
*/
import tdaConfig from 'lib/util/tda.config';

var __tdaDir = tdaConfig.tda.code === 'GST10' ? 'GS10' : tdaConfig.tda.code;
export default {
  localImgPath: function (localPath) {
    if (localPath.indexOf('/sharedssny/') >= 0) {
      return localPath.replace('/web_docs', '');
    }
    return localPath.replace('web_docs', __tdaDir);
  }
};
